// Form Table — data + resolver for the widget. Same row shape and columns as
// the League Table (see leagueTable.ts → shapeLeagueRows / LEAGUE_COLUMNS); only
// the data source and controls differ (venue + timeline instead of season).
//
// MIGRATION FRICTION: formTableData.json is dummy data extracted verbatim from
// the legacy data.js so the component stays pure (data-in, no window access).
// Delete it (and this resolver) when app-api supplies the table.

import type { LeagueTeam } from "./leagueTable.js";
import rawData from "./formTableData.json" with { type: "json" };

export const FORM_TABLE_DATA = rawData as unknown as Record<
  string,
  readonly LeagueTeam[]
>;

export const FORM_DEFAULT_HA = "All";
export const FORM_DEFAULT_TIMELINE = "10";

/**
 * Teams for a venue + timeline window, keyed `"{ha}-{timeline}"` (e.g.
 * "Home-5"); falls back to "All-10" for an unknown combination, matching the
 * legacy renderer.
 */
export function getFormTeams(
  ha: string,
  timeline: string
): readonly LeagueTeam[] {
  return FORM_TABLE_DATA[`${ha}-${timeline}`] ?? FORM_TABLE_DATA["All-10"]!;
}
